import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import ProcessoExpandidoService from '../services/ProcessoExpandidoService';
import MensagemStore
    from "@/store/MensagemStore";

export type StatusGeracaoResumoAguia = 'gerando' | 'concluido' | 'erro';

export interface GeracaoResumoAguia {
    idProcesso: number;
    numeroProcesso: string;
    status: StatusGeracaoResumoAguia;
    mensagem?: string;
}

class ResumoAguiaGeracaoStore {
    geracoes: GeracaoResumoAguia[] = [];
    expandido = true;

    constructor() {
        makeObservable(this, {
            geracoes: observable,
            expandido: observable,
            possuiGeracoes: computed,
            quantidadeGerando: computed,
            gerarResumo: action,
            remover: action,
            limpar: action,
            toggleExpandido: action
        });
    }

    isResumoGeradoSenaoGerarResumo = async (identificadorProcesso: number,
                                            numeroProcesso: string, callback?: () => void): Promise<boolean> => {
        try {
            await ProcessoExpandidoService.consultarResumoDocumentosAguiaPublico(identificadorProcesso, true);

            return true;
        } catch (error) {
            if (callback) {
                callback();
            }

            this.gerarResumo(
                identificadorProcesso,
                numeroProcesso
            );
            MensagemStore.apresentarAviso('Foi solicitado geração do resumo ÁguIA para poder criar o voto.');
        }

        return false;
    }

    get possuiGeracoes() {
        return this.geracoes.length > 0;
    }

    get quantidadeGerando() {
        return this.geracoes.filter(geracao => geracao.status === 'gerando').length;
    }

    gerarResumo(idProcesso: number, numeroProcesso: string) {
        const geracaoExistente = this.geracoes.find(geracao => geracao.idProcesso === idProcesso);

        if (geracaoExistente?.status === 'gerando') {
            return;
        }

        if (geracaoExistente) {
            geracaoExistente.status = 'gerando';
            geracaoExistente.mensagem = undefined;
        } else {
            this.geracoes.push({
                idProcesso,
                numeroProcesso,
                status: 'gerando'
            });
        }

        this.expandido = true;
        this.executarGeracao(idProcesso);
    }

    private executarGeracao = async (idProcesso: number) => {
        try {
            await ProcessoExpandidoService.gerarResumoDocumentosAguiaPublico(idProcesso);
            runInAction(() => {
                const geracao = this.geracoes.find(item => item.idProcesso === idProcesso);
                if (geracao) {
                    geracao.status = 'concluido';
                    geracao.mensagem = 'Resumo gerado.';
                }
            });
        } catch (error) {
            runInAction(() => {
                const geracao = this.geracoes.find(item => item.idProcesso === idProcesso);
                if (geracao) {
                    geracao.status = 'erro';
                    geracao.mensagem = error?.response?.data?.detail
                        || error?.response?.data?.message
                        || 'Não foi possível gerar o resumo.';
                }
            });
        }
    }

    remover(idProcesso: number) {
        const index = this.geracoes.findIndex(geracao => geracao.idProcesso === idProcesso);
        if (index > -1) {
            this.geracoes.splice(index, 1);
        }
    }

    limpar() {
        this.geracoes = [];
    }

    toggleExpandido() {
        this.expandido = !this.expandido;
    }
}

export default new ResumoAguiaGeracaoStore();
